import { _Button } from "./_Button";
import { CascadiaButtonProps } from "./types";

interface Props extends CascadiaButtonProps {}

export function DangerButton(props: Props) {
  return (
    <_Button
      color="text-inverse"
      fill="background-danger-strong"
      focusStyle="focus-action"
      hoverFill="background-danger-strong-hover"
      shadow="shadow-button"
      {...props}
    />
  );
}
